module.exports = __webpack_public_path__ + "img/water side -95(2).a813ef4d.jpeg";